<template>
    <div class="version2-header-two">
        <span>{{ title }}</span>
        <img src="../../../../static/version2/右边板块标题样式.png" alt="">

    </div>
</template>
<script>
export default {
  props: {
    title: String
  },
  data() {
    return {

    }
  }
}
</script>
